import { Link } from '@/components';
import { CategoryModel } from '@/types';
import { useTranslations } from 'next-intl';

type AtAGlanceDriversModel = {
  macroDrivers: CategoryModel[];
};

const AtAGlanceDrivers = ({ macroDrivers }: AtAGlanceDriversModel) => {
  const t = useTranslations();

  return (
    <div className="flex w-full flex-col pl-6">
      <h3 className="my-4 h-7 text-lg leading-7 font-bold">{t('report.atAGlance.$macroDrivers')}</h3>
      <div className="flex flex-wrap gap-4">
        {macroDrivers.map((driver, index) => (
          <Link
            key={index}
            className="btn bg-gray-4 h-10 !px-7 !text-xs !font-medium !tracking-[1px] text-white uppercase"
            link={driver.landingPageLink}
          />
        ))}
      </div>
    </div>
  );
};

export default AtAGlanceDrivers;
